export const convertStrToBool = (param: string | null | undefined) => {
  return param === "true";
};
